'use strict';

(function () {
  'use strict';

  angular.module('msActivities').controller('ActivityFeedbackCtrl', ActivityFeedbackCtrl);

  ActivityFeedbackCtrl.$inject = ['$log', 'feedbackSvc', 'trainStorageSvc', 'activity', 'activityRouter', 'NotifyingSvc'];

  /* @ngInject */
  function ActivityFeedbackCtrl($log, feedbackSvc, trainStorageSvc, activity, activityRouter, NotifyingSvc) {
    var vm = this;
    vm.title = 'ActivityFeedbackCtrl';
    vm.next = next;

    activate();

    ////////////////

    function activate() {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
        pageTitle: activity.title
      });
      trainStorageSvc.getTrain().then(function (train) {
        vm.train = train;
      });
      $log.debug('ActivityFeedback ctrl activate');
    }

    function next() {
      feedbackSvc.activityFeedback(activity, vm.feedback).finally(activityRouter.navigateTrain);
    }
  }
})();